(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["essano-haircare-event-styles"] && !Shopify.designMode) return;
  try {
    if (!window.__hclCowlendarKeys) {
    window.__hclCowlendarKeys = true;
    document.addEventListener('keydown', function (event) {
      var target = event.target;
      if (!target || !target.hasAttribute || !target.hasAttribute('data-cowlendar-btn')) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      target.click();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
